import { render, staticRenderFns } from "./DataTableWithoutResizeColumn.vue?vue&type=template&id=95d3fe4e&scoped=true&"
import script from "./DataTableWithoutResizeColumn.vue?vue&type=script&lang=js&"
export * from "./DataTableWithoutResizeColumn.vue?vue&type=script&lang=js&"
import style0 from "./DataTableWithoutResizeColumn.vue?vue&type=style&index=0&id=95d3fe4e&prod&lang=scss&scoped=true&"
import style1 from "./DataTableWithoutResizeColumn.vue?vue&type=style&index=1&id=95d3fe4e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d3fe4e",
  null
  
)

export default component.exports